import { Component, OnInit, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ParseService } from '../../../../../shared/common/parse/parse.service';
import { ProfileService } from '../../profile.service';
import { ToastBaseModel } from '../../../../../shared/common/toast-data-model';
import { QueryInterface } from '../../../../../shared/common/parse/query-interface';
import { GetSetOperations } from '../../../../../shared/common/helper/profile';
import { GetOperations } from '../../../../../shared/common/helper/dropdown';
import { ActivatedRoute } from '@angular/router';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';

@Component({
  selector: 'app-professional',
  templateUrl: './professional.component.html',
  styleUrls: ['./professional.component.scss']
})

export class ProfessionalComponent implements OnInit {

  currentProjectDetails = [];
  previousProjectDetails = [];
  systemDetailsForm: FormGroup;
  formErrors: any;
  about: any;
  userroles: any;
  userroles1: any;
  profileroles: any;
  profileDetails1: any;
  instance: any;
  organisationLists: any;
  seatingLists: any;
  departmentLists: any;
  reportingtoLists: any;
  designationLists: any;
  operatingSystemList = [];
  systemTypeList = [];
  operatingLists: any;
  project: string = '';
  client: string = '';
  startdat: number[] = [];
  fromdate: string = '';
  todate: string = '';
  enddat: number[] = [];
  reportingto: string;
  experience = [];
  tabexperience = [];
  status: string;
  noticePeriod: any;
  profileId: any;
  objectId = '';
  cols: any[];
  cols1: any[];
  profileValue: any;
  resignationForm: FormGroup;
  projectName: any;
  clientName: any;
  value: any;
  currentUser: any;
  currentProfileUser = this.parseService.instance.User.current();
  userProfileId: any;
  firstname: String;
  lastname: String;
  obj_Id = this.parseService.instance.User.current().id;
  empRole = '';
  routeId = '';
  noticetime: notice[] = [
    { value: 30, viewValue: '30' },
    { value: 60, viewValue: '60' },
    { value: 90, viewValue: '90' }
  ];
  releasedDate: Date;
  oldSystemValue: any;
  oldResignationValue: any;
  isSystemDetailsFormUpdated: boolean;
  isResignationFormUpdated: boolean;


  constructor(
    private toastMessage: ToastBaseModel,
    private _formBuilder: FormBuilder,
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    public dialog: MatDialog,
    private parseService: ParseService,
    private toastr: ToastrService,
    private profileDropDown: GetOperations,
    private queryInterface: QueryInterface,
    private profileInterface: GetSetOperations,
    private route: ActivatedRoute,
    private dateConvertor: DateConvertor,
    private sessionHandler: SessionHandler,
    private storageConfiguration: StorageConfiguration,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService
  ) {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');

    this.cols = [
      { header: 'Project', field: 'project' },
      { header: 'Client', field: 'client' },
      { header: 'Project Type', field: 'typeOfProject' },
      { header: 'Start Date', field: 'startDate' },
      { header: 'End Date', field: 'endDate' },
      { header: 'Status', field: 'status' }];

    this.cols1 = [
      { header: 'Project', field: 'project' },
      { header: 'Client', field: 'client' },
      { header: 'Start Date', field: 'startDate' },
      { header: 'Project Type', field: 'typeOfProject' },
      { header: 'End Date', field: 'endDate' },
      { header: 'Status', field: 'status' }];

    this.systemDetailsForm = this._formBuilder.group({
      systemId: ['', Validators.required],
      deviceName: ['', Validators.required],
      virusScan: [''],
      systemType: ['', Validators.required],
      biggbossStatus: [''],
      operatingSystem: ['', Validators.required]
    });

    this.resignationForm = this.formBuilder.group({
      resignationAppliedDate: ['', Validators.required],
      noticePeriod: ['', Validators.required],
      resignationAcceptedDate: ['', Validators.required],
      releasedDate: ['', Validators.required],
    });

    this.profileService.aboutOnChanged.subscribe(about => {
      this.about = about;
    });

  }

  /*
   ** ==========================================================
   **   On init
   ** ==========================================================
   */

  ngOnInit() {
    if (this.empRole !== 'Admin'){
      this.systemDetailsForm.disable();
    }
    this.objectId = this.parseService.instance.User.current().get('profile').id;
    this.profileId = this.parseService.instance.User.current().get('profile').id;

    let id = '';
    this.route.params.subscribe(params => {
      id = params['id'];
      this.routeId = id;

      this.routeId = this.routeId ? this.routeId : this.profileId
    });
    if (id != undefined) {
      this.objectId = id;
    }

    if (this.objectId) {
      var user = new this.parseService.instance.Object('Profile');
      user.id = this.objectId;
    }

    this.getProfileToUser();

  }

  getProfileToUser() {
    this.queryInterface.executeQuery(this.parseService, "User", [
      { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: this.objectId } },
      { condition: "include", value: "profile" },
    ]).then(results => {
      let result = results[0]
      this.objectId = result.id
      var user = new this.parseService.instance.Object('User');

      user.id = result.id
      this.currentUser = user
      this.getCurrentProjects();
      this.getDropDowns();
      this.getSystemDetails();
      this.getResignationDetails();
    })
  }

  async getCurrentProjects() {
    let result = [];
    let result1 = [];
    let queryInstance = this.parseService.instance.Object.extend("ProjectMembers")
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo("isActive", true);
    query.include("project")
    query.include("project.client")
    query.equalTo("user", { __type: "Pointer", className: "_User", objectId: this.objectId });
    query.find().then(results => {
      for (let i = 0; i < results.length; i++) {
        let projectResults = JSON.stringify(results[i]);
        let proModel = JSON.parse(projectResults);
        if (proModel.status == "Assigned") {
          result.push({
            position: i + 1,
            project: proModel.project.projectInfo.projectName,
            client: proModel.project.client.companyInfo.firstName + " " + proModel.project.client.companyInfo.lastName,
            startDate: this.dateConvertor.moment(proModel.startDate.iso),
            endDate: this.dateConvertor.moment(proModel.endDate.iso),
            status: proModel.status,
            objectId: proModel.objectId,
            // typeOfProject: proModel.project.projectType
            typeOfProject: proModel.project.schedulerStatus
          });
          this.currentProjectDetails = result;
        }
        else {
          if (proModel.status != "Assigned") {
            result1.push({
              position: i + 1,
              project: proModel.project.projectInfo.projectName,
              client: proModel.project.client.companyInfo.firstName + " " + proModel.project.client.companyInfo.lastName,
              startDate: this.dateConvertor.moment(proModel.startDate.iso),
              endDate: this.dateConvertor.moment(proModel.endDate.iso),
              status: proModel.status,
              objectId: proModel.objectId,
              typeOfProject: proModel.project.projectType
            });
            this.previousProjectDetails = result1;
          }
        }
      }
    }
    ).catch(err => {
      this.sessionHandler.handleParseError(err)
    })
    return [];
  }


  /*
   ** ==========================================================
   **  Table Values Get Function
   ** ==========================================================
   */

  async getSystemDetails() {
    await this.queryInterface.executeQuery(this.parseService, "Profile", [
      { condition: "equalTo", field: "objectId", value: this.routeId },
    ]).then(result => {
      var results = result[0];
      this.profileValue = results.get('systemInfo');
      this.profileId = results.id
      this.systemDetailsForm.patchValue({
        systemId: this.profileValue.systemId ? this.profileValue.systemId : '',
        deviceName: this.profileValue.deviceName ? this.profileValue.deviceName : '',
        virusScan: this.profileValue.virusScan ? this.profileValue.virusScan : '',
        systemType: this.profileValue.systemType ? this.profileValue.systemType : '',
        operatingSystem: this.profileValue.operatingSystem ? this.profileValue.operatingSystem : '',
        biggbossStatus: this.profileValue.biggbossStatus ? this.profileValue.biggbossStatus : ''
      });
      if (this.systemDetailsForm.valid){
        this.isSystemDetailsFormUpdated = true;
      }
      this.oldSystemValue = JSON.parse(JSON.stringify(this.systemDetailsForm.value));
    });
  }

  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(
        dropdownresults
      ),
      systemObj = this.operatingSystemList,
      systemTypeObj = this.systemTypeList,
      systemType = profileDropDownValue.systemType,
      operatingSystem = profileDropDownValue.operatingSystem;

    for (var i = 0; i < operatingSystem.length; i++) {
      systemObj.push(operatingSystem[i]);
    }
    for (var i = 0; i < systemType.length; i++) {
      systemTypeObj.push(systemType[i]);
    }
  }

  addGMTOffset(somedate) {
    let date = somedate._d;
    if (!date) {
      date = somedate;
    }
    var datewithoffset = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    return datewithoffset;
  }

  /*
   ** ==========================================================
   **   Get Resignation Details
   ** ==========================================================
   */

  async getResignationDetails() {
    await this.queryInterface.executeQuery(this.parseService, 'Profile', [{ condition: 'equalTo', field: 'objectId', value: this.routeId }]).then(result => {
      var results = result[0];
      this.profileValue = results.get('resignationInfo');
      this.resignationForm.patchValue({
        resignationAppliedDate: new Date(this.profileValue.resignationAppliedDate) ? new Date(this.profileValue.resignationAppliedDate) : '',
        noticePeriod: this.profileValue.noticePeriod ? this.profileValue.noticePeriod : '',
        resignationAcceptedDate: new Date(this.profileValue.resignationAcceptedDate) ? new Date(this.profileValue.resignationAcceptedDate) : '',
        releasedDate: new Date(this.profileValue.releasedDate) ? new Date(this.profileValue.releasedDate) : ''
      });
      this.oldResignationValue = JSON.parse(JSON.stringify(this.resignationForm.value));
    });
  }

  /*
   ** ==========================================================
   **   System Details Save Function
   ** ==========================================================
   */

  async systemDetailsSave() {
    var profileValues = this.systemDetailsForm.value;

    let data = {
      systemInfo: {
        systemId: profileValues.systemId,
        deviceName: profileValues.deviceName,
        operatingSystem: profileValues.operatingSystem,
        systemType: profileValues.systemType,
        biggbossStatus: profileValues.biggbossStatus,
        virusScan: profileValues.virusScan
      }
    };
    if (this.systemDetailsForm.valid) {

      if (this.empRole != 'Employee') {
        let activities = await this.activityCenterService.getActivity(this.oldSystemValue, profileValues, '');
        this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.routeId);
      }

      await this.profileInterface.updateProfessional(this.profileId, data).then(res => {
        this.getSystemDetails();
      });
      if (this.isSystemDetailsFormUpdated){
      this.toastr.success(this.toastMessage.Update);
      } else{
      this.toastr.success(this.toastMessage.Save);
      }
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  /*
   ** ==========================================================
   **   Resignation Save Function
   ** ==========================================================
   */

  async resignationDetailsSave() {
    if (this.resignationForm.valid) {
      var profileValues = this.resignationForm.value;
      if (profileValues.releasedDate._d !== undefined) {
        profileValues.releasedDate = profileValues.releasedDate._d
      }
      let data = {
        resignationInfo: {
          resignationAppliedDate: this.dateConvertor.addGMTOffset(new Date(new Date(profileValues.resignationAppliedDate).setHours(6))).toISOString(),
          noticePeriod: profileValues.noticePeriod,
          resignationAcceptedDate: this.dateConvertor.addGMTOffset(new Date(new Date(profileValues.resignationAcceptedDate).setHours(6))).toISOString(),
          releasedDate: this.dateConvertor.addGMTOffset(new Date(new Date(profileValues.releasedDate).setHours(6))).toISOString(),
        }
      };

      if (this.empRole != 'Employee') {
        let activities = await this.activityCenterService.getActivity(this.oldResignationValue, profileValues, '');
        this.activityCenterService.createActivity(activities, this.hardCodedValues.profileView, this.routeId);
      }

      this.profileInterface.updateProfessional(this.profileId, data).then(async res => {
        await this.getResignationDetails();
      });
      if (this.isResignationFormUpdated){
        this.toastr.success(this.toastMessage.Save);
      } else {
        this.toastr.success(this.toastMessage.Save);
      }
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }

  }

  selectDays(event) {
    var acceptedDate = new Date(this.resignationForm.value.resignationAcceptedDate);
    var dateChangeLimit = new Date(acceptedDate.setDate(acceptedDate.getDate() + event));
    this.releasedDate = dateChangeLimit;
    this.resignationForm.patchValue({
      releasedDate: new Date(dateChangeLimit)
    });
    if (this.resignationForm.valid){
      this.isResignationFormUpdated = true;
    }
  }



}


export interface CurrentProject {
  position: string;
  project: string;
  client: string;
  startDate: string;
  endDate: string;
  status: string;
}

export interface PreviousProject {
  No: string;
  project: string;
  client: string;
  startdate: string;
  enddate: string;
  status: string;
}

export interface notice {
  value: number;
  viewValue: string;
}
